"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const PopoverModalForm_1 = require("../../components/PopoverModalForm");
const reducers_1 = require("../../../../reducers");
const actions_1 = require("../../../../actions");
const getLimitTypeStyle = (device) => ({
    height: device === 'Mobile' ? 72 : 55,
    width: device === 'Mobile' ? '100%' : 352,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
});
const radioButtonStyle = {
    outerStyle: {
        height: 18,
        width: 18,
    },
};
const getAddButton = (device) => {
    if (device === 'Desktop') {
        return (React.createElement(src_1.Button, { key: "limit-change-button", text: "Change", type: "regular", style: {
                innerStyle: {
                    fontSize: 17,
                },
                outerStyle: {
                    height: null,
                    lineHeight: '24px',
                },
            }, mouseDownColors: {
                active: src_1.turquoise,
                inactive: src_1.aquamarine,
            } }));
    }
    return React.createElement(src_1.ChangeIcon, { key: "limit-change-icon", fill: src_1.titanium });
};
const LimitTypeSelector = ({ closePopoverModalForm, device, limitType, updateActivePopover, updateFrequencyLimits }) => {
    const closePopoverModal = () => {
        closePopoverModalForm();
        setTimeout(() => updateActivePopover(''), device === 'Mobile' ? 500 : 0);
    };
    return (React.createElement(PopoverModalForm_1.default, { addButton: getAddButton(device), editButton: getAddButton(device), field: "limit-type-selector", popoverFormInputProps: {
            fieldStyle: {
                marginTop: 0,
                padding: device === 'Desktop' ? '24px 0 23px' : 0,
                minHeight: 'none',
                width: '100%',
            },
            id: 'limit-type-selector',
            isEditingText: false,
            label: 'Each device can receive the notification',
            media: device,
            text: limitType,
        }, popoverModalProps: (handleClosePopoverModal) => ({
            placement: 'left',
        }), popoverNavbarProps: (handleClosePopoverModal) => ({
            buttonLeft: 'Cancel',
            buttonLeftCallback: handleClosePopoverModal,
        }), presentationType: device !== 'Mobile' ? 'popover' : 'modal' },
        React.createElement("div", { key: "limit-type-selector" },
            device === 'Mobile' && (React.createElement(src_1.Text, { size: "h2", text: "Each device can receive the notification", textStyle: { margin: '24px 24px 8px 24px' } })),
            React.createElement(src_1.SelectableList, { device: device },
                React.createElement("div", { key: "only-once", onClick: (e) => {
                        e.stopPropagation();
                        updateFrequencyLimits([
                            {
                                count: 1,
                                interval: null,
                            },
                        ]);
                        closePopoverModal();
                    }, style: getLimitTypeStyle(device) },
                    React.createElement(src_1.Text, { text: "Only once", size: device === 'Mobile' ? 'large' : 'medium' }),
                    React.createElement(src_1.RadioButton, { selected: limitType === 'Only once', style: radioButtonStyle })),
                React.createElement("div", { key: "an-unlimited-amount", onClick: (e) => {
                        e.stopPropagation();
                        updateFrequencyLimits([]);
                        closePopoverModal();
                    }, style: getLimitTypeStyle(device) },
                    React.createElement(src_1.Text, { text: "An unlimited amount", size: device === 'Mobile' ? 'large' : 'medium' }),
                    React.createElement(src_1.RadioButton, { selected: limitType === 'An unlimited amount', style: radioButtonStyle })),
                React.createElement("div", { key: "no-more-than", onClick: (e) => {
                        e.stopPropagation();
                        updateFrequencyLimits([
                            {
                                count: 1,
                                interval: { value: 1, unit: 'd' },
                            },
                        ]);
                        closePopoverModal();
                    }, style: getLimitTypeStyle(device) },
                    React.createElement(src_1.Text, { text: "No more than...", size: device === 'Mobile' ? 'large' : 'medium' }),
                    React.createElement(src_1.RadioButton, { selected: limitType === 'No more than...', style: radioButtonStyle }))))));
};
const mapStateToProps = (state) => ({
    limitType: reducers_1.getAutomatedLimitType(state),
});
const mapDispatchToProps = (dispatch) => ({
    closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
    updateActivePopover: (field) => dispatch(actions_1.updateActivePopover(field)),
    updateFrequencyLimits: (limits) => dispatch(actions_1.updateFrequencyLimits(limits)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(LimitTypeSelector);
